const faFilm = {
  prefix: 'fal',
  iconName: 'film',
  icon: [
    448,
    512,
    [127902, 62368, 'film-alt', 'film-simple'],
    'f008',
    'M128 368l0 80 192 0 0-384-192 0 0 304zM96 384l-64 0 0 32c0 17.7 14.3 32 32 32l32 0 0-64zm0-32l0-80-64 0 0 80 64 0zm0-112l0-80-64 0 0 80 64 0zm0-112l0-64-32 0C46.3 64 32 78.3 32 96l0 32 64 0zM352 352l64 0 0-80-64 0 0 80zm0-112l64 0 0-80-64 0 0 80zm0-112l64 0 0-32c0-17.7-14.3-32-32-32l-32 0 0 64zm0 256l0 64 32 0c17.7 0 32-14.3 32-32l0-32-64 0zM64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z',
  ],
};
export default faFilm;
